import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux'
import StepControlButton, {CONTROL_NOICON, CONTROL_PREV} from '../../components/navigation/StepControlButton'
import MediaQuery from 'react-responsive'
import PromotionCodeBox from '../cart/PromotionCodeBox'

import OrderNoteForm from "../clientdata/OrderNoteForm";
import * as StepLabels from '../../constants/StepLabels'


import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPen} from "@fortawesome/pro-light-svg-icons/faPen";
import PriceListingRow from "../../components/PriceListingRow";
import {queryCartCheckout} from "../../actions/Cart";
import {selectStep} from "../../actions/StepControl";
import {showPopupWithIframe} from "../../actions/Popup";
import BillingPeriodGroup from "../configuration/BillingPeriodGroup";
import {faQuestionCircle} from "@fortawesome/pro-light-svg-icons/faQuestionCircle";
import {APP_MODE_AGENCYSERVER_ADD_PROJECT, APP_MODE_OUTSOURCING, APP_MODE_PRODUCT_CHANGE, PAYMENT_TYPE_SEPA, SALUTATION_PREFIXES} from "../../constants/General";
import {isMode} from "../../selectors/Mode";
import {getBaseArticle, getCartContractPartner, getCartNote, getCartRecommendedAccount, getRecommendedAccountTypes} from "../../selectors/SimpleSelectors";
import {getActualBillingAddress, getActualBillingAddressSmall, getContractPartnerAddressSmall, isNewCustomerSelected} from "../../selectors/Forms";
import {getCartSummary, getFirstArticleData, getMainArticleInCart} from "../../selectors/Cart";
import SummaryArticleListing from "../../components/summary/SummaryArticleListing";
import SummaryTotalListing from "../../components/summary/SummaryTotalListing";
import ReactTooltip from "react-tooltip";
import {delve} from "../../util/util";
import MigrationHintBox from "../../components/MigrationHintBox";
import {queryPreUpgradeCheck} from "../../actions/Accounts";
import HintWrapper from "../../components/HintWrapper";
import {isAgencyServerCMSArticle, isAgencyServerDevProjectArticle, isAgencyServerShopArticle, isConfigurableArticle} from "../../selectors/ArticleNumbers";
import {TermsText} from "../../components/summary/TermsText";
import {dsgvoArticles} from "../../config/Config";

class SummaryStep extends Component {

    static propTypes = {
        stepLabel: PropTypes.string.isRequired,
        nextLabel: PropTypes.string,
        prevLabel: PropTypes.string.isRequired,
        onButtonNextClick: PropTypes.func,
        onButtonPrevClick: PropTypes.func
    }


    constructor(props) {

        super(props)
    }

    componentDidMount() {
        ReactTooltip.rebuild()

        if (this.props.isPotentialIpChange) {
            this.props.preUpgradeCheck();
        }
    }

    handleCheckoutClick = (e) => {
        if (!this.props.isFetching && !this.props.orderComplete) {
            this.props.checkoutCart()
        }
    }


    render() {

        const cartSummary = this.props.cartSummary

        if (!cartSummary.paymentSettings) {
            return null
        }

        const contractPartnerAddress = this.props.contractPartnerAddressSmall.join('\r\n')
        const billingType = cartSummary.paymentSettings.billingType === PAYMENT_TYPE_SEPA ? 'Lastschrift' : 'Rechnung'
        const invoiceDelivery = cartSummary.paymentSettings.postalInvoice ? this.props.billingAddressSmall.join('\n') : (this.props.actualBillingAddress ? this.props.actualBillingAddress.emailAddress : '')

        let isFreeOrder = true;
        if (cartSummary && cartSummary.total && (cartSummary.total.setupFee > 0 || cartSummary.total.priceMonthly > 0 || cartSummary.total.domainPricesMonthly > 0)) {
            isFreeOrder = false;
        }

        const ctaLabel = isFreeOrder ? "Kostenfrei bestellen" : "Kostenpflichtig bestellen";

        const showBillingPeriodGroup = (!isFreeOrder || cartSummary.total.freeRuntime > 0) && delve(this.props.firstArticleData, "billing.allowDurationModification") && (this.props.agencyServerAdditionMode || !this.props.isNewCustomerSelected);

        let finalHint = null;
        const isAgency2021Promotion = delve(cartSummary, 'promotions.0.code') === 'AGENTUR2021';

        if (isAgency2021Promotion) {
            finalHint = <HintWrapper
                theme='blue'
                content={'Aktiviert: Agentur-Server 2 Monate kostenlos mit bis zu 3 Projekten. Wir rufen dich nach Abschluss der Bestellung an. (Mo. - Fr.)'}
            />
        }

        let additionalHint = null;
        let hideEdit = false;

        if (this.props.mainArticleInCart === '75000') {
            hideEdit = true;
            additionalHint = (
                <HintWrapper
                    theme={'blue'}
                >
                    TYPO3 10 ELTS hat eine Gesamtlaufzeit von vier Jahren: vom 1. Mai 2023 bis zum 30. April 2027.
                    <br/>
                    <br/>
                    Die Gesamtlaufzeit unterteilt sich in folgende Abschnitte:
                    <ul>
                        <li>
                            01. Mai 2023 bis 30. April 2024
                        </li>
                        <li>
                            01. Mai 2024 bis 30. April 2025
                        </li>
                        <li>
                            01. Mai 2025 bis 30. April 2026
                        </li>
                        <li>
                            01. Mai 2026 bis 30. April 2027
                        </li>
                    </ul>
                    Kosten: 240,00 € zzgl. MwSt. pro Abschnitt
                    <br/>
                    <br/>
                    Der Vertrag verlängert sich automatisch um einen weiteren Abschnitt, wenn dieser nicht 30 Tage vor Ablauf des Abschnitts gekündigt wird.
                </HintWrapper>
            );
        }

        if (this.props.mainArticleInCart === '75001') {
            hideEdit = true;
            additionalHint = (
                <HintWrapper
                    theme={'blue'}
                >
                    TYPO3 9 ELTS hat eine Gesamtlaufzeit von einem Jahr: vom 1. Oktober 2024 bis zum 30. September 2025.
                    <br/>
                    <br/>
                    Die Gesamtlaufzeit unterteilt sich in folgende Abschnitte:
                    <ul>
                        <li>
                            01. Oktober 2024 bis 30. September 2025
                        </li>
                    </ul>
                    Kosten: 240,00 € zzgl. MwSt. pro Abschnitt
                </HintWrapper>
            );
        }

        if (this.props.mainArticleInCart === '75002') {
            hideEdit = true;
            additionalHint = (
                <HintWrapper
                    theme={'blue'}
                >
                    TYPO3 11 ELTS hat eine Gesamtlaufzeit von vier Jahren: vom 1. November 2024 bis zum 31. Oktober 2028.
                    <br/>
                    <br/>
                    Die Gesamtlaufzeit unterteilt sich in folgende Abschnitte:
                    <ul>
                        <li>
                            01. November 2024 bis 31. Oktober 2025
                        </li>
                        <li>
                            01. November 2025 bis 31. Oktober 2026
                        </li>
                        <li>
                            01. November 2026 bis 31. Oktober 2027
                        </li>
                        <li>
                            01. November 2027 bis 31. Oktober 2028
                        </li>
                    </ul>
                    Kosten: 240,00 € zzgl. MwSt. pro Abschnitt
                    <br/>
                    <br/>
                    Der Vertrag verlängert sich automatisch um einen weiteren Abschnitt, wenn dieser nicht 30 Tage vor Ablauf des Abschnitts gekündigt wird.
                </HintWrapper>
            );
        }

        if (this.props.mainArticleInCart === '75003') {
            hideEdit = true;
            additionalHint = (
                <HintWrapper
                    theme={'blue'}
                >
                    TYPO3 12 ELTS hat eine Gesamtlaufzeit von vier Jahren: vom 1. Mai 2026 bis zum 30. April 2030.
                    <br/>
                    <br/>
                    Die Gesamtlaufzeit unterteilt sich in folgende Abschnitte:
                    <ul>
                        <li>
                            01. Mai 2026 bis 30. April 2027
                        </li>
                        <li>
                            01. Mai 2027 bis 30. April 2028
                        </li>
                        <li>
                            01. Mai 2028 bis 30. April 2029
                        </li>
                        <li>
                            01. Mai 2029 bis 30. April 2030
                        </li>
                    </ul>
                    Kosten: 288,00 € zzgl. MwSt. pro Abschnitt
                    <br/>
                    <br/>
                    Der Vertrag verlängert sich automatisch um einen weiteren Abschnitt, wenn dieser nicht 30 Tage vor Ablauf des Abschnitts gekündigt wird.
                </HintWrapper>
            );
        }
        return (
            <div className="step-display__page summary-step">

                <h1>Bestellübersicht</h1>

                {this.props.ipChanges ? <MigrationHintBox/> : null}

                <div className="summary-step__overview-head">
                    <h2>Dein Tarif</h2>
                    {!hideEdit ? <button
                        type="button"
                        onClick={(e) => {
                            if (isMode(APP_MODE_PRODUCT_CHANGE)) {
                                this.props.selectStep(StepLabels.PRODUCT_CHANGE)
                            } else if (isMode(APP_MODE_OUTSOURCING)) {
                                this.props.selectStep(StepLabels.OUTSOURCING_TARGET)
                            } else {
                                this.props.selectStep(StepLabels.CONFIG)
                            }
                        }}
                    ><FontAwesomeIcon icon={faPen}/></button> : null}
                </div>

                <SummaryArticleListing cartSummary={cartSummary}/>

                {additionalHint}

                {cartSummary.domains.length > 0 ? <div className="summary-step__overview-head">
                    <h2>Domains</h2>
                    <button
                        type="button"
                        onClick={(e) => {
                            this.props.selectStep(StepLabels.DOMAIN)
                        }}
                    ><FontAwesomeIcon icon={faPen}/></button>
                </div> : null}


                <div className={"summary-step__domains"}>
                    {cartSummary.domains.map(domainDataEntry => {

                        const domainTitle = <div>{domainDataEntry.domainName}<span
                            className="bold"
                        >{"." + domainDataEntry.domainEnding}</span></div>;

                        return (
                            <div
                                className={"summary-step__domains__domain"}
                                key={domainDataEntry.domainName + domainDataEntry.domainEnding}
                            >
                                <PriceListingRow
                                    title={domainTitle}
                                    price={Number(domainDataEntry.priceMonthly).toFixed(2) + " €"}
                                    tax={true}
                                    monthly={true}
                                    caption={domainDataEntry.isInclusiveDomain ? "Inklusivdomain" : "Monatliche Kosten"}
                                />
                                {domainDataEntry.setupFee ? <PriceListingRow
                                    className={"summary-step__domains__domain--setup"}
                                    title={"Einrichtungsgebühr"}
                                    price={Number(domainDataEntry.setupFee).toFixed(2) + " €"}
                                    tax={true}
                                    caption={domainTitle}
                                /> : null}
                            </div>
                        )
                    })}
                </div>

                {this.props.isNewCustomerSelected ?
                    <div className="summary-step__overview-head">
                        <h2>Persönliche Daten</h2>
                        <button
                            type="button"
                            onClick={(e) => {
                                this.props.selectStep(StepLabels.CLIENTDATA)
                            }}
                        ><FontAwesomeIcon icon={faPen}/></button>
                    </div> : null}

                {this.props.isNewCustomerSelected ?
                    <div className="summary-step__data-overview">
                        <div className="summary-step__data-overview__group">
                            {this.props.contractPartner.vat ? <div>{this.props.contractPartner.vat}</div> : null}
                            {this.props.contractPartner.company ?
                                <div>{this.props.contractPartner.company}</div> : null}
                        </div>
                        <div className="summary-step__data-overview__group">
                            <div>{SALUTATION_PREFIXES[this.props.contractPartner.salutation || ''] + this.props.contractPartner.firstName + " " + this.props.contractPartner.lastName}</div>
                            <div>{contractPartnerAddress}</div>
                        </div>
                        <div className="summary-step__data-overview__group">
                            <div>{this.props.contractPartner.emailAddress}</div>
                            <div>{this.props.contractPartner.phone}</div>
                        </div>
                        {this.props.note ? <div className="summary-step__data-overview__group">
                            <div>Notiz</div>
                            <div>{this.props.note}</div>
                        </div> : null}
                    </div> : null}

                {this.props.isNewCustomerSelected ?
                    <div className="summary-step__overview-head">
                        <h2>Zahlungsart</h2>
                        <button
                            type="button"
                            onClick={(e) => {
                                this.props.selectStep(StepLabels.PAYMENT)
                            }}
                        ><FontAwesomeIcon icon={faPen}/></button>
                    </div> : null}


                {this.props.isNewCustomerSelected ?
                    <div className="summary-step__data-overview">
                        <div className="summary-step__data-overview__group">
                            <PriceListingRow
                                title={"Zahlungsart"}
                                caption={billingType}
                            />
                        </div>
                        {cartSummary.paymentSettings.billingType === PAYMENT_TYPE_SEPA ?
                            <div className="summary-step__data-overview__group">
                                <PriceListingRow
                                    title={"Kontoinhaber"}
                                    caption={cartSummary.paymentSettings.accountHolder}
                                />
                                <PriceListingRow
                                    title={"IBAN"}
                                    caption={cartSummary.paymentSettings.iban}
                                />
                                {cartSummary && cartSummary.paymentSettings && cartSummary.paymentSettings.bic ?
                                    <PriceListingRow
                                        title={"BIC"}
                                        caption={cartSummary.paymentSettings.bic}
                                    /> : null}
                            </div> : null}
                        <div className="summary-step__data-overview__group">
                            <PriceListingRow
                                title={"Rechnung"}
                                hint={cartSummary.paymentSettings.postalInvoice ? "pro Rechnung " : ""}
                                tax={true}
                                price={Number(cartSummary.paymentSettings.postalInvoice.setupFee) > 0 ? (Number(cartSummary.paymentSettings.postalInvoice.setupFee).toFixed(2) + " €") : "kostenfrei"}
                                caption={(cartSummary.paymentSettings.postalInvoice ? "Per Post an: \n" : "Per E-Mail an: \n") + invoiceDelivery}
                            />
                        </div>
                    </div> : null
                }

                {!this.props.isNewCustomerSelected ?
                    <div className="summary-step__overview-head">
                        <h2>Vertragspartner</h2>
                    </div> : null}

                {!this.props.isNewCustomerSelected ?
                    <div className="summary-step__data-overview">

                        <div className="summary-step__data-overview__group">
                            {this.props.existingClientData.vat ? <div>{this.props.existingClientData.vat}</div> : null}
                            {this.props.existingClientData.company ?
                                <div>{this.props.existingClientData.company}</div> : null}
                        </div>
                        <div className="summary-step__data-overview__group">
                            <div>{SALUTATION_PREFIXES[this.props.existingClientData.salutation || ''] + this.props.existingClientData.firstName + " " + this.props.existingClientData.lastName}</div>
                            <div>{
                                [
                                    this.props.existingClientData.address.street + " " + this.props.existingClientData.address.houseNumber,
                                    this.props.existingClientData.address.zip + " " + this.props.existingClientData.address.city,
                                    this.props.existingClientData.address.country.name.de
                                ].join('\n')
                            }</div>
                        </div>
                        <div className="summary-step__data-overview__group">
                            <div>{this.props.existingClientData.email}</div>
                            <div>{this.props.existingClientData.contact.telephone}</div>
                        </div>
                        {this.props.note ? <div className="summary-step__data-overview__group">
                            <div>Notiz</div>
                            <div>{this.props.note}</div>
                        </div> : null}
                    </div> : null}

                {!this.props.isNewCustomerSelected ?
                    <div className="summary-step__overview-head"><h2>Bestellnotiz</h2></div> : null}

                {!this.props.isNewCustomerSelected ?
                    <div className="summary-step__order-note"><OrderNoteForm/></div> : null}

                <MediaQuery
                    maxWidth={1023}
                    className="summary-step__promotion-code"
                >
                    <h2>Sie haben einen Aktionscode?</h2>
                    <PromotionCodeBox/>
                </MediaQuery>

                {showBillingPeriodGroup ? <BillingPeriodGroup/> : null}

                <SummaryTotalListing
                    cartSummary={cartSummary}
                    lineThrough={isAgency2021Promotion}
                />

                {finalHint}

                {this.props.cartIsTesting ? <div className={"summary-step__test testing-tooltip"}>
                    <div className={"summary-step__test__text"}>
                        Kostenloser Test für 10 Tage
                    </div>
                    <div
                        className={"summary-step__tooltip"}
                        data-for={"global"}
                        data-tip={"Das Paket kann während des Testzeitraums jederzeit im Kundencenter (login.mittwald.de) gekündigt werden."}
                        data-effect={"solid"}
                        data-place={"left"}
                    >
                        <FontAwesomeIcon icon={faQuestionCircle}/>
                    </div>
                </div> : null}

                <div className="summary-step__agb">
                    <TermsText article={this.props.mainArticleInCart} label={ctaLabel}/>
                </div>

                <div className="step-display__page__control">
                    {this.props.prevLabel !== "" ? <StepControlButton
                        type={CONTROL_PREV}
                        label={this.props.prevLabel}
                        onClick={this.props.onButtonPrevClick}
                    /> : null}
                    {this.props.nextLabel !== "" ? <StepControlButton
                        type={CONTROL_NOICON}
                        label={ctaLabel}
                        onClick={this.handleCheckoutClick}
                        showSpinner={this.props.isCheckingOut || this.props.orderComplete}
                    /> : null}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {

    const cartSummary = getCartSummary(state)

    return {
        ipChanges: state.productSelection.ipChanges,
        isPotentialIpChange: true,
        contractPartner: getCartContractPartner(state),
        recommendedAccount: getCartRecommendedAccount(state),
        note: getCartNote(state),
        recommendedAccountTypes: getRecommendedAccountTypes(state),
        contractPartnerAddressSmall: getContractPartnerAddressSmall(state),
        billingAddressSmall: getActualBillingAddressSmall(state),
        actualBillingAddress: getActualBillingAddress(state),
        cartSummary: cartSummary,
        isNewCustomerSelected: isNewCustomerSelected(state),
        isCheckingOut: state.cart.isCheckingOut,
        isFetching: state.cart.isFetching,
        orderComplete: state.appState.orderComplete,
        existingClientData: state.clientDataStep.clientData,
        baseArticle: getBaseArticle(state),
        cartIsTesting: state.cart.testing,
        cartIsAvManager: cartSummary.baseArticleInCart ? dsgvoArticles.includes("" + cartSummary.baseArticle.articleNumber) : false,
        mainArticleInCart: getMainArticleInCart(state),
        agencyServerAdditionMode: isMode(APP_MODE_AGENCYSERVER_ADD_PROJECT),
        firstArticleData: getFirstArticleData(state)
    }
}

const mapDispatchToProps = (dispatch) => {

    return {
        preUpgradeCheck: () => {
            dispatch(queryPreUpgradeCheck())
        },
        checkoutCart: () => {
            dispatch(queryCartCheckout())
        },
        selectStep: (step) => {
            dispatch(selectStep(step))
        },
        showAGBPopup: () => {
            dispatch(showPopupWithIframe('https://www.mittwald.de/bestellung/popups/agb'))
        },
        showPolicyPopup: () => {
            dispatch(showPopupWithIframe('https://www.mittwald.de/bestellung/popups/datenschutz'))
        },
        showRepealPopup: () => {
            dispatch(showPopupWithIframe('https://www.mittwald.de/bestellung/popups/agb#widerrufsbelehrung'))
        },
        showIFramePopup: (src) => {
            dispatch(showPopupWithIframe(src))
        }
    }

}
export default connect(mapStateToProps, mapDispatchToProps)(SummaryStep)



/** WEBPACK FOOTER **
 ** ./src/containers/summary/SummaryStep.js
 **/